import { DraftReturnSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const skipAddReturnItems = {
  name: "skipAddReturnItems" as const,
  input: z.object({ draftReturnId: zExt.objectId() }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
